module.exports = __webpack_public_path__ + "Tenant.bf9f2ecaecb9bf5aa654fe06fc620391.hashedasset.svg";